import { render } from "./GalleryGrid.vue?vue&type=template&id=61d2ded7&scoped=true"
import script from "./GalleryGrid.vue?vue&type=script&lang=js"
export * from "./GalleryGrid.vue?vue&type=script&lang=js"

import "./GalleryGrid.vue?vue&type=style&index=0&id=61d2ded7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d2ded7"]])

export default __exports__